import enter from './enter';
import backspace from './backspace';
import leftArrow from './leftArrow';
import _delete from './delete';
import tab from './tab';
import dateComponents from '../../../../../../../../../constants/dateComponents';
import selectAll from './selectAll';
import expandedWithBullet from './expandedWithBullet';
import undoRedo from './undoRedo';
import rightArrow from './rightArrow';
import KEY_CODES from '../../../../../../editJournal/constants/keyCodes';

export default (params) => {
  const { event, editor, setExpertTips, showExpertTips } = params;
  const {
    value: { focusBlock },
  } = editor;

  const isUndoRedo = undoRedo(event);
  if (isUndoRedo) return true;

  if (showExpertTips && showExpertTips && event.which === KEY_CODES.ESCAPE) {
    setExpertTips({ showExpertTips: false });
  }

  /**
   * Copy/Cut/Paste
   */
  if ((event.ctrlKey || event.metaKey) && event.which === KEY_CODES.C)
    return true;
  if ((event.ctrlKey || event.metaKey) && event.which === KEY_CODES.X)
    return true;
  if ((event.ctrlKey || event.metaKey) && event.which === KEY_CODES.V)
    return true;
  if (
    (event.ctrlKey || event.metaKey) &&
    (event.which === KEY_CODES.B ||
      event.which === KEY_CODES.I ||
      event.which === KEY_CODES.U)
  )
    return false;
  if (focusBlock) {
    const { type: focusBlockType } = focusBlock;

    /**
     * Prevent default in date components
     */
    if (dateComponents[focusBlockType]) {
      if (
        event.which !== KEY_CODES.DOWN &&
        event.which !== KEY_CODES.UP &&
        event.which !== KEY_CODES.LEFT &&
        event.which !== KEY_CODES.RIGHT &&
        event.which !== KEY_CODES.TAB
      ) {
        event.preventDefault();
        return true;
      }
    }

    /**
     * Common utils for all sections
     */

    const isSelectionExpanded = expandedWithBullet(params);
    if (isSelectionExpanded) return true;

    const isBackspace = backspace(params);
    if (isBackspace) return true;

    const isDelete = _delete(params);
    if (isDelete) return true;

    const isEnter = enter(params);
    if (isEnter) return true;

    const isLeftArrow = leftArrow(params);
    if (isLeftArrow) return true;

    const isRightArrow = rightArrow(params);
    if (isRightArrow) return true;

    const isTab = tab(params);
    if (isTab) return true;

    const isSelectAll = selectAll({ ...params, focusBlock });
    if (isSelectAll) return true;
  }

  return false;
};
